var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table-cell-text',[_vm._v(" "+_vm._s(_vm._f("hours")(_vm.item.duration))+" hour"),(_vm.item.duration !== 3600)?[_vm._v("s")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }